import React from 'react';
import PropTypes from 'prop-types';

import { qbElementTypeNames } from 'helpers/constants';

import ErrorMessage from './ErrorMessage';
import CollapsibleContent from './CollapsibleContent';

const MessageContent = ({
  errorFilter, showNumber, syncLogs, call, tick, triggerText
}) => {
  const messages = syncLogs.elErrors.filter(el => errorFilter.includes(el.QbElementTypeId));

  if (messages.length === 0) return null;

  const elMessages = messages.map(error => (
    <ErrorMessage
      key={ error.QbFullname }
      call={ call }
      elementId={ error.QbElementId }
      elementType={ qbElementTypeNames[error.QbElementTypeId] }
      errorStamp={ error.ErrorStamp }
      recordName={ error.QbFullname }
      text={ error.Error }
      tick={ tick }
    />
  ));

  return (
    <CollapsibleContent
      messages={ elMessages }
      showNumber={ showNumber }
      trigger={ `${triggerText} (${messages.length})` }
    />
  );
};

MessageContent.defaultProps = {
  showNumber: false,
};

MessageContent.propTypes = {
  errorFilter: PropTypes.arrayOf(PropTypes.number).isRequired,
  showNumber: PropTypes.bool,
  syncLogs: PropTypes.shape({
    elErrors: PropTypes.arrayOf(PropTypes.shape({
      Error: PropTypes.string,
      ErrorStamp: PropTypes.string,
      QbElementId: PropTypes.number,
      QbElementTypeId: PropTypes.number,
      QbFullname: PropTypes.string,
    })),
  }).isRequired,
  triggerText: PropTypes.string.isRequired,

  // functions
  call: PropTypes.func.isRequired,
  tick: PropTypes.func.isRequired,
};

export default MessageContent;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/components/MessageContent.js